// extracted by mini-css-extract-plugin
module.exports = {"BtnWrapper":"ClearDueModal_BtnWrapper__6HCvZ"};